// This file exists to enable real unit testing for Multipass without using the mocked module -> see /tests.global.js for reference
// URL Builders
export const linkUserAccountUrl = () => `/users/me/link`
